import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Avatar, Chip, Popover, Typography } from '@material-ui/core';

const ChipContainer = ({ list }) => {
  const { users } = useSelector(({ bizMeta }) => bizMeta);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentUser, setCurrentUser] = useState('');

  const handlePopoverOpen = (event, username) => {
    setAnchorEl(event.currentTarget);
    setCurrentUser(username);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const getUserCredentials = (uname = '') => {
    let username = uname !== '' ? uname : currentUser;

    const userIndx = users.findIndex(
      data => data.UserID.trim() === username.trim()
    );

    if (userIndx === -1) {
      return {
        username: username,
        fullname: username,
        position: ''
      };
    }

    return {
      username: users?.[userIndx]?.UserID || username,
      fullname: `${users?.[userIndx]?.FName || ''} ${users?.[userIndx]?.LName ||
        ''}`,
      position: users?.[userIndx]?.Position || ''
    };
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const { username, fullname, position } = getUserCredentials();

  return (
    <Box>
      {list.map((data, i) => (
        <Chip
          aria-describedby={id}
          key={i}
          avatar={
            <Avatar src={`/api/images/user/${data}/avatar.jpg`}>
              {data === '' ? '' : data[i === 0 ? 0 : 1].toUpperCase()}
            </Avatar>
          }
          label={data === '' ? 'None' : getUserCredentials(data).fullname}
          color="primary"
          size="small"
          style={{ margin: '.1em' }}
          clickable
          onClick={e => handlePopoverOpen(e, data)}
        />
      ))}
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        onClose={handlePopoverClose}
      >
        <Box p={2} display="flex">
          <Box m={1}>
            <Avatar
              color="primary"
              src={`/api/images/user/${username}/avatar.jpg`}
            >
              {(username?.[0] || '').toUpperCase()}
            </Avatar>
          </Box>
          <Box m={1}>
            <Typography variant="h4" align="center">
              {fullname}
            </Typography>
            <Typography variant="caption" align="center">
              {position}
            </Typography>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default ChipContainer;
